module.exports = __webpack_public_path__ + "img/brand-ft-logo-landscape-coloured.d0978040.svg";